module.exports = __webpack_public_path__ + "media/scholarship_winners/winners-tell-us-about-it-widget-ba8ccb3c.png";